import { omit } from 'lodash';
import GetRecaptchaVerificationToken from './GetRecaptchaVerificationToken';
import { AppStore } from '..';
import api from '../../api';

type Args = {
  Email: string;
  Referrer?: string | null;
  onError?: (a: { errorMessage?: string; errorType?: string }) => void;
};

export default async function RequestUserAccount(store: AppStore, args: Args) {
  store.dispatch({
    type: 'REQUEST_USER_ACCOUNT_START',
  });
  const dispatchArgs = omit(args, 'onError');
  const RecaptchaVerificationToken = await GetRecaptchaVerificationToken(store, {
    action: 'signup',
  });

  try {
    const response = await api.dispatch<string>('RequestUserAccount', store, {
      App: 'Web',
      ...dispatchArgs,
      RecaptchaVerificationToken,
      RecaptchaSiteKey: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
    });

    if (!response.Success) {
      store.dispatch({
        type: 'REQUEST_USER_ACCOUNT_FAIL',
        message: response.Error,
      });
      // eslint-disable-next-line
      args.onError != null &&
        args.onError({
          errorMessage: response.Error,
          errorType: response.ErrorType,
        });
      return;
    }

    store.dispatch({
      type: 'REQUEST_USER_ACCOUNT_SUCCESS',
      message: response.Result,
    });
  } catch (error: unknown) {
    store.dispatch({
      type: 'REQUEST_USER_ACCOUNT_FAIL',
      message: (error as Error).message,
    });
  }
}
